import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getIsPaymentsAvailable, getIsPaymentsConfigured, getIsPaymentsPermissionsGranted, getPaymentEligibilityRequestState
// @ts-expect-error untyped file
} from 'FormsUI/selectors/Payments';
const usePaymentPermissions = () => {
  const isPaymentsAvailable = useSelector(getIsPaymentsAvailable);
  const isPaymentsConfigured = useSelector(getIsPaymentsConfigured);
  const isPaymentsPermissionsGranted = useSelector(getIsPaymentsPermissionsGranted);
  const paymentEligibilityRequestState = useSelector(getPaymentEligibilityRequestState);
  return useMemo(() => ({
    isPaymentsAvailable,
    isPaymentsConfigured,
    isPaymentsPermissionsGranted,
    paymentEligibilityRequestState
  }), [isPaymentsAvailable, isPaymentsConfigured, isPaymentsPermissionsGranted, paymentEligibilityRequestState]);
};
export default usePaymentPermissions;